export default "__VITE_ASSET__BCGeaits__"